export function stickyNav() {
    const header = $(".header");
    const headerHeight = header.innerHeight();
    const stickyArea = $(".sticky-area");
    const stickyNav = $('.aside-nav.sticky');
    const sections = $('[data-anchor-id]');
    const innerWraper = $('.inner-wrapper');
    let scrollTop;

    $('#article').find('[data-anchor-id]').each(function(idx){
        var _anchorId   = false;
        var _title      = false;

        if($(this).hasClass('subscribe-block')) {
            _title = $(this).find('h3').text();
            _anchorId = $(this).data('anchor-id');
        } else if($(this).attr('id') !== undefined) {
            _title = $(this).text();
            _anchorId = $(this).attr('id');
        }

        if(_title && _anchorId ){
            $('#aside-nav-anchors').append('<li><a href="#' + _anchorId + '" class="has-anchor">' + _title + '</a></li>');
        } else {

            $('#aside-nav-anchors').remove();
        }
        $('.aside-nav').addClass('loaded');
    });

    if(!$('#aside-nav-anchors').find('li').html()){
        $('#aside-nav-anchors').remove();
    }

    $('#aside-nav-anchors').find('.has-anchor').on('click', function (e) {
        e.preventDefault();

        const target = $(this).attr("href").slice(1);

        if (target) {
            const anchoredBlock = $('[data-anchor-id="' + target + '"]');
            const anchoredH4 = $('h4#' + target );

            if (anchoredBlock.length) {
                $("html, body").animate({ scrollTop: anchoredBlock.offset().top - headerHeight + 40 }, 500);
            }
            if (anchoredH4.length) {
                $("html, body").animate({ scrollTop: anchoredH4.offset().top - headerHeight + 40 }, 500);
            }
        }
    });

    function sticky() {
        if($('.aside-nav').hasClass('sticky') && window.innerWidth > 1023) {
            scrollTop = $(window).scrollTop();
            const stickyAreaHeight = stickyArea.innerHeight();
            const stickyAreaTop = stickyArea.offset().top;
            const stickyAreaBottom = stickyAreaHeight + stickyAreaTop - headerHeight;

            if (scrollTop > stickyAreaTop - headerHeight && scrollTop < stickyAreaBottom - headerHeight) {
                stickyArea.addClass('has-fixed-child');
            } else if (scrollTop > stickyAreaBottom - headerHeight) {
                stickyArea.removeClass('has-fixed-child');
            } else {
                stickyNav.find('li').removeClass('active');
                stickyArea.removeClass('has-fixed-child');
            }


            if (stickyArea.hasClass('has-fixed-child')) {
                sections.each(function (index, section) {
                    const $this = $(section);
                    const itemOffsetTop = $this.offset().top;
                    const itemHeight = $this.outerHeight(true);
                    let sliderNavItem = stickyNav.find('a[href="#' + $this.attr('data-anchor-id').toLowerCase() + '"]').parent();
                    if ((scrollTop + headerHeight - 30 >= itemOffsetTop) && (scrollTop <= itemOffsetTop + itemHeight)) {
                        if (!sliderNavItem.hasClass('active')) {
                            sliderNavItem.siblings().removeClass('active');
                            sliderNavItem.addClass('active');
                            $this.addClass('active');
                        }
                    } else {
                        $this.removeClass('active');
                    }
                })
            }
            if (innerWraper.length) {
                let h = stickyNav.innerHeight()
                innerWraper.css('margin-top', `-${h}px`)
            }
        } else {
            stickyArea.removeClass('has-fixed-child');
            if (innerWraper.length) {
                innerWraper.removeAttr('style')
            }

        }
    }

    $(window).on("load scroll resize", function () {
        sticky();
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/stickyNav.js